import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { DistrictsListWrapper } from './districts-list/DistrictsList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const districtsBreadcrumbs: Array<PageLink> = [
  {
    title: 'District Management',
    path: '/admin/pages/districts',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/districts/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const DistrictsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='districts'
          index
          element={
            <>
              <PageTitle breadcrumbs={districtsBreadcrumbs}>Districts list</PageTitle>
              <DistrictsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/districts/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/districts' />} />
    </Routes>
  )
}

export default DistrictsPage
